import Image from 'next/image';
import { AppNextLink } from '@/features/app-next-link';
import { cn } from '@/utils/cn';
import { Categories } from '../../types';
interface Props {
  title: string;
  icon: string;
  href?: string;
  id: string;
  isLinkInDrawer: boolean;
  subMenuChildren?: Categories[];
  onSelect: () => void;
  isSelected?: boolean;
  roundTopLeft?: boolean;
  roundBottomLeft?: boolean;
  showBottomBorder?: boolean;
}
function SubMenuBox({
  icon,
  title,
  href,
  isLinkInDrawer,
  onSelect,
  isSelected,
  roundTopLeft,
  roundBottomLeft,
  showBottomBorder = true
}: Props) {
  const roundingClass = cn({
    'rounded-none': !roundTopLeft && !roundBottomLeft,
    'rounded-l-md': roundTopLeft && roundBottomLeft,
    'rounded-tl-md': roundTopLeft && !roundBottomLeft,
    'rounded-bl-md': !roundTopLeft && roundBottomLeft
  });
  const borderBottomClass = showBottomBorder ? 'border-b border-border-gray-light' : 'border-b-0';
  const containerClassName = `flex flex-col items-center justify-center gap-1 text-text-black w-[104px] h-[96px] cursor-pointer ${roundingClass} ` + (isSelected ? `bg-white ${borderBottomClass}` : `bg-surface-solid-50 border border-r-none border-border-gray-light ${borderBottomClass}`);
  return <div data-sentry-component="SubMenuBox" data-sentry-source-file="sub-menu-box.tsx">
            {isLinkInDrawer ? <AppNextLink href={href || ''} className={containerClassName} prefetch={false}>
                    <Image src={icon} alt={title} width={32} height={32} unoptimized />
                    <span className='text-center text-xs font-medium'>{title}</span>
                </AppNextLink> : <button type='button' className={containerClassName} onClick={onSelect} aria-label={title}>
                    <Image src={icon} alt={title} width={32} height={32} unoptimized />
                    <span className='text-center text-xs font-medium'>{title}</span>
                </button>}
        </div>;
}
export default SubMenuBox;